import * as React from "react";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CodeEditor } from "../../group/identityMatcher/codeEditor";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { formSet, formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { store } from "../../../store";
import { ImportButtonRaw, DropZone } from "../../../components/import";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { SecretCodeEditorObfuscated } from "./SecretCodeEditorObfuscated";

interface Props {}
export const SecretDataAzureSDK: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();

  const value = useCpFormValue(`azureSdk`);

  return (
    <>
      <CardContent>
        <div className="flex items-center gap-4 mb-2">
          <div>Azure SDK Secret Data</div>
          <ImportButtonRaw
            formId={id}
            fieldName="azureSdk"
            actionLabel="Import Azure SDK secret"
            accept=".json"
            existingHasContent={!!value?.trim()}
            explanation={
              <div className="text-xs">
                <div className="font-semibold mb-1">Accepted format:</div>
                <div><strong>.json</strong> — Azure service principal credentials</div>
                <div className="mt-1 opacity-75">Typically downloaded from Azure Portal</div>
              </div>
            }
          />
        </div>
        <SecretCodeEditorObfuscated visibilityName="meta.codeEditorVisibility.azureSdk" contentName="azureSdk">
          <DropZone
            formId={id}
            fieldName="azureSdk"
            actionLabel="Import Azure SDK secret"
            accept={[".json"]}
          >
            <CodeEditor
              value={value}
              setValue={(value) => {
                formSetValue(id, `azureSdk`, value);
              }}
              onChange={() => {
                const name = "azureSdk";
                formSet(id, `fieldStates.${name}.modified`, true);

                const form = store.getState().form.instances[id];
                const onChangeCounter = form.meta.onChangeCounter;
                formSet(id, `meta.onChangeCounter`, onChangeCounter + 1);
              }}
              onFocus={() => {
                const name = "azureSdk";
                formSet(id, `fieldStates.${name}.focused`, true);
                formSet(id, `fieldStates.${name}.visited`, true);
              }}
              onBlur={() => {
                const name = "azureSdk";
                formSet(id, `fieldStates.${name}.focused`, false);
                formSet(id, `fieldStates.${name}.touched`, true);

                const form = store.getState().form.instances[id];
                const onBlurCounter = form.meta.onBlurCounter;
                formSet(id, `meta.onBlurCounter`, onBlurCounter + 1);
              }}
              language={"javascript"}
              options={{
                basicSetup: {
                  lineNumbers: true,
                },
                style: {
                  maxHeight: 500,
                  overflow: "auto",
                  fontSize: 14,
                },
              }}
            />
          </DropZone>
        </SecretCodeEditorObfuscated>
        <CpErrorWarning name={`azureSdk`} />
      </CardContent>
    </>
  );
};
